import React, { useState } from "react";
import { ChevronDown, ExternalLink } from "lucide-react";

/** Collapsible sources drawer — used in article pages & mobile. */
export default function SourceDrawer({ sources = [], defaultOpen = true }) {
  const [open, setOpen] = useState(defaultOpen);
  if (!sources || sources.length === 0) return null;

  return (
    <section className="mt-8 io-card-el p-5" data-testid="source-drawer">
      <button
        onClick={() => setOpen((v) => !v)}
        className="w-full flex items-center justify-between"
        data-testid="source-drawer-toggle"
      >
        <div>
          <div className="kicker" style={{ color: "#D4AF37" }}>Sources used in this article</div>
          <div className="text-xs font-mono text-[var(--io-muted)] mt-1">{sources.length} reference{sources.length > 1 ? "s" : ""} · last verified today</div>
        </div>
        <ChevronDown size={18} className={`text-[var(--io-text-2)] transition-transform ${open ? "rotate-180" : ""}`} />
      </button>

      {open && (
        <ol className="mt-5 space-y-3">
          {sources.map((s, i) => (
            <li key={i} className="flex items-start gap-3 text-sm" data-testid={`source-item-${i}`}>
              <span className="font-mono text-[11px] text-[var(--io-muted)] pt-0.5 w-6 shrink-0">[{i + 1}]</span>
              <div className="flex-1">
                <div className="font-sans text-[var(--io-text)] font-medium">{s.name || "Source"}</div>
                {s.url && (
                  <a href={s.url} target="_blank" rel="noreferrer noopener"
                    className="font-mono text-[11px] text-[#3B82F6] hover:text-[var(--io-gold)] inline-flex items-center gap-1 break-all"
                    data-testid={`source-url-${i}`}>
                    {s.url.length > 80 ? s.url.substring(0, 80) + "…" : s.url}
                    <ExternalLink size={10} />
                  </a>
                )}
              </div>
            </li>
          ))}
        </ol>
      )}
    </section>
  );
}
